import { useState, useEffect, useCallback } from 'react';

export interface UseHashReturn {
    hash: string;
    setHash: (hash: string) => void;
    clearHash: () => void;
    isHash: (target: string) => boolean;
}

export function useHash(): UseHashReturn {
    const [hash, setHashState] = useState(() => window.location.hash.slice(1));

    useEffect(() => {
        const handleHashChange = () => {
            setHashState(window.location.hash.slice(1));
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    const setHash = useCallback((newHash: string) => {
        window.location.hash = newHash;
    }, []);

    const clearHash = useCallback(() => {
        window.history.pushState('', document.title, window.location.pathname + window.location.search);
        setHashState('');
    }, []);

    const isHash = useCallback(
        (target: string) => {
            return hash === target;
        },
        [hash]
    );

    return { hash, setHash, clearHash, isHash };
}
